export default function shortenedPath(path: string) {
  const spaces = path.split(" > ");
  if (spaces.length > 0) {
    return `${spaces[0]} > ... > ${spaces[spaces.length - 1]}`;
  }

  return "";
}
